<!-- 配送车辆证照操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="100px" label-position="right" size="mini" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" :disabled="dataActionBox.actionType>1" :show-message="false">
                    <el-row>
                      <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow==1" :rules="formOneValue.isRequired == 1 ? [{required: true, trigger: ['blur', 'change']}] : []">
                        <!-- 系统字段 -->
                        <div v-if="formOneValue.isReserved == 0">
                          <!-- 证照有限期 -->
                          <el-tooltip v-if="formOneValue.entityField == 'vmLicensecode'" class="item" :disabled="sendDataInfo.vmLicensecode==null||sendDataInfo.vmLicensecode==''?true:false || sendDataInfo.vmLicensecode.length<=9" effect="dark"
        :content="sendDataInfo.vmLicensecode" placement="bottom-start">
                          <el-input v-if="formOneValue.entityField == 'vmLicensecode'" v-model.trim="sendDataInfo.vmLicensecode" :maxlength="$store.state.inputLength" @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.entityField)" :disabled="formOneValue.isChange==0" clearable>
                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                          </el-input>
                          </el-tooltip>
                          <df-date :isType="true" :isdisabled="formOneValue.isChange == 0" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                          <el-select filterable :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'lityId'" v-model="sendDataInfo[formOneValue.entityField]">
                            <el-option v-for="(values,keys) in dictionariesData" :key="keys" :label="values.diName" :value="values.diValue">
                            </el-option>
                          </el-select>
                          <div v-else-if="formOneValue.entityField == 'uploadVoList'">
                            <el-upload class="upload-demo" :action="requesUrl+'/upload/fileupload'" :headers='token' :multiple="true" :on-success="fileUpload" :before-remove="beforeRemove" :file-list="fileList" list-type="picture">
                              <el-button size="small" type="primary">点击上传</el-button>
                              <!-- <div slot="tip" class="el-upload__tip">不超过500kb</div> -->
                            </el-upload>
                          </div>
                          <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable></el-input>
                        </div>
                        <!-- 扩展字段 -->
                        <div v-if="formOneValue.isReserved == 1">

                          <!-- 自填 -->
                          <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable></el-input>
                          <!-- 选择数据来源 -->
                          <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-else :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable></el-input>
                        </div>
                      </el-form-item>
                    </el-row>

                  </el-form>
                </div>

              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foots">
          <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
          <el-button type="primary" @click="initActionBox" v-if="dataActionBox.actionType!=2">取消</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==0">保存</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==1">保存</el-button>
        </div>
      </div>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" :parentSearchData="parentSearchData" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>
</template>

<script>
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
  name: "vehicleLicenseAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      isLoaded: false,
      showTabs: "",
      formDataList: [],
      sendDataInfo: {
        lityId: "", //	证照类型
        uploadVoList: {
          busType: "", //	业务类型
          createTime: "", //	上传时间
          creater: "", //	上传人
          createrName: "", //	上传人名称
          fileId: "", //	文件id
          fileName: "", //	文件名
          fileType: "", //	文件所属业务类型
          fileUrl: "", //	上传路径
          type: "", //	文件类型,1图片、2文件、3视频、4音频、5未识别
        },
        vlHolder: "", //	证照持有人
        vlRedate: "", //	发证日期
        vlTername: "", //	证照名称
        vlTernumber: "", //	证照号
        vlTervalidity: "", //	证照有效期
        vmId: "", //	车辆ID
        vmLicensecode: "",  //车牌号
      },
      dictionariesData: [], //单位类型
      imgUrl: "", //图片显示根路径
      requesUrl: "",
      token: {
        token: sessionStorage.getItem("token"),
      },
      fileList: [],
      uploadVoList: [],
      DialogVisible: false,
      seTitle: "",
      seWidth: "",
      seType: "",
      parentSearchData: {}
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    async fileUpload(event) {
      event.result.forEach((item, index) => {
        this.uploadVoList.push(item);
      });
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        const index = this.uploadVoList.findIndex(item => item.fileUrl == file.url.split(`${this.$store.getters.getConfig.imgUrl}/`)[1])
        this.uploadVoList.splice(index, 1)
      })
    },
    openSearch(sId, type) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seType = type;
      this.parentSearchData[type] = this.sendDataInfo[type];
      if (type == 'ormId') {
        this.parentSearchData["ormName"] = this.sendDataInfo["ormName"];
      }
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (this.seType == "vmLicensecode") {
          console.log(val);
          this.sendDataInfo.vmId = val.vmId;
          this.sendDataInfo.vmLicensecode = val.vmLicensecode;
        }
      }
    },
    showPrintPlan() {
      // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(
          this.actionData.orderId,
          this.actionData.printSouce,
          this.actionData.printJurId
        );
      } else {
        return;
      }
    },
    //图片地址转换
    pictureShow(data) {
      var imgList = [];
      data.forEach((item) => {
        imgList.push(this.imgUrl + "/" + item.fileUrl);
      });
      return imgList;
    },
    //保存
    async sendDataAction() {
      let flag = false;
      this.$refs["sendDataInfo"].validate((valid) => {
        if (valid) {
        } else {
          this.$message({
            message: "请完善证照信息表单的必填信息",
            type: "error",
          });
          flag = true;
          return false;
        }
      });
      this.sendDataInfo.uploadVoList = JSON.parse(JSON.stringify(this.uploadVoList));
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
      let responseData;

      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.vehicleLicenceadd(sendData);
      } else if (this.dataActionBox.actionType == 1) {
        responseData = await this.$http.vehicleLicencemodify(sendData);
      } else {
        //审核
      }
      if (responseData.status == 200) {
        // this.dataActionBox.showStatus = false
        this.$emit("drawerCancel");
        this.$refs["sendDataInfo"].resetFields();
        this.init();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //取消新增
    initActionBox() {
      if (this.dataActionBox.actionType == 5) return this.$emit("drawerCancel");
      this.$emit("drawerCancel");
      // this.dataActionBox.showStatus = false
      this.init();
      this.$refs["sendDataInfo"].resetFields();
    },

    //初始化
    init() {
      for (const key in this.sendDataInfo) {
        if (
          key == "supaddresses" ||
          key == "supbankinfos" ||
          key == "suplicencelinfos" ||
          key == "smManrange" ||
          key == "smProrange" ||
          key == "smTrerange"
        ) {
          this.sendDataInfo[key] = [];
        } else if (key == "supfinancelinfos") {
          for (const item in this.sendDataInfo[key]) {
            this.sendDataInfo[key][item] = "";
          }
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      this.fileList = []
      this.uploadVoList = []
      this.dataActionBox.boxTitle = "";
    },

    //父级传入 获取列表
    openBox() {
      this.dataActionBox.actionType = this.actionData.cate;
      this.formDataList = this.actionData.formData;
      var oldData = this.actionData.oldData;
      this.showTabs = this.actionData.formData[0].jciName;
      this.init();
      this.dataActionBox.showStatus = true;
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增证照";
        this.dataActionBox.openMode = "ltr";
      } else {
        if (this.dataActionBox.actionType == 1) {
          this.dataActionBox.boxTitle = "修改证照";
          this.dataActionBox.openMode = "rtl";
          for (let key in oldData) {
            if (key == 'uploadVoList') {
              oldData[key].forEach((item, index) => {
                this.fileList.push({
                  name: item.fileName,
                  url: this.imgUrl + '/' + item.fileUrl,
                })
                this.uploadVoList.push(JSON.parse(JSON.stringify(item)))
              })
              this.$set(this.sendDataInfo, key, oldData[key])
            } else {
              this.$set(this.sendDataInfo, key, oldData[key]);
            }
          }
        } else if (this.dataActionBox.actionType == 2) {
          this.dataActionBox.boxTitle = "查看信息";
          var dataInfo = JSON.parse(JSON.stringify(oldData));
          for (let key in dataInfo) {
            this.sendDataInfo[key] = dataInfo[key];
            if (
              key == "smManrange" ||
              key == "smProrange" ||
              key == "smTrerange"
            ) {
              this.sendDataInfo[key] = dataInfo[key] ? dataInfo[key].toString() : ""
            }
          }
        } else {
          this.sendDataInfo = oldData;
          this.dataActionBox.boxTitle = "证照信息审核";
        }
        this.sendDataInfo.smIntype = Number(oldData.smIntype);
      }
    },
    //获取单位类型
    async getCateDictionariesDatas() {
      let responseData = await this.$http.getCateDictionariesData({
        ids: [32],
      });
      if (responseData.status == 200) {
        this.dictionariesData = responseData.result;
        console.log(this.dictionariesData, "222");
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },


    //获取生产/经营范围
    async getQueryScopeByType(type) {
      //type 范围类型0.生产范围1.经营范围2.诊疗
      let ormId = sessionStorage.getItem('ormId')
      let params = {
        type: type,
        ormId: ormId
      }
      let responseData = await this.$http.queryScopeByType(params);
      if (responseData.status == 200) {
        return responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
        return [];
      }
    },
    imgur() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.imgur();
    this.$nextTick(() => {
      this.openBox();
      this.isLoaded = true;
    });
    this.getCateDictionariesDatas(); //单位类型
    this.imgUrl = this.$store.getters.getConfig.imgUrl;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.baseForm .el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
